module.exports = __webpack_public_path__ + "img/Human_symbol_9.e6b563e5.png";